import React from 'react';
import './Footer.scss';

const Footer = () => {
	return (
		<footer className="footer">
			<div className="footer__content">
				<p>© 2025 Jeremy Boutin - Senior Software Engineer</p>
			</div>
		</footer>
	);
};

export default Footer;
